module.exports = __webpack_public_path__ + "static/김건어물-9201b81c99e6a331ee86de86ab16d5db.jpg";